module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-76x76.png";